import type { FeatureOn } from "./types";

/**
 * Whether Message Prioritization is available to the workspace. Either flipper grants access: the
 * `message_prioritization_m1` beta flipper or the `message_prioritization` entitlement flipper.
 *
 * @param featureOn - a `featureOn` checker (`useFeatureOn()` or `@lib/featureFlipper`)
 * @returns true when either flipper is on
 */
export const isMessagePrioritizationEnabled = (featureOn: FeatureOn): boolean =>
  featureOn("message_prioritization_m1") || featureOn("message_prioritization");
